import { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";

import HeaderMain from "./components/Header/HeaderMain";
import Loading from "./components/Loading/Loading";
import { ANCLAS } from "./constants/routes";
//corporativo
import homeCorporativo from "../src/assets/images/homeCorporativo.png";
import textoCorporativo from "../src/assets/images/textoCorporativo.svg";
//desarrollo
import desarrolloCorporativo from "../src/assets/images/desarrolloCorporativo.jpg";
import textoDesarrollo from "../src/assets/images/textoDesarrollo.svg";
import botonDesarrollo from "../src/assets/images/botonDesarrollo.svg";
//laboratorio
import laboratorioCorporativo from "../src/assets/images/laboratorioCorporativo.jpg";
import textoLaboratorio from "../src/assets/images/textoLaboratorio.svg";
import botonLaboratorio from "../src/assets/images/botonLaboratorio.svg";
//Cuidarte
import cuidarte2 from "../src/assets/images/cuidarte2.jpg";
import botonCuidarte from "../src/assets/images/botonCuidarte.svg";
import logoCuidarte from "../src/assets/images/logoCuidArte2.svg";
//ambiental
import ambiental from "../src/assets/images/fondo ambiental.jpg";
import logoAmbiental from "../src/assets/images/LogoMSWAmbiental-blanco.svg";
import botonAmbiental from "../src/assets/images/botonAmbiental.svg";
//aleante
import aleanteCorporativo from "../src/assets/images/aleanteCorporativo.png";
import logoAleante from "../src/assets/images/logoAleante2.svg";
import botonAleante from "../src/assets/images/botonAleante.svg";

import "./App.css";
// Import Swiper styles
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/navigation";
import "swiper/css/pagination";

// import required modules
import { EffectFade, Navigation, Pagination, Autoplay } from "swiper/modules";

function App() {
  const [cargar, setCargar] = useState<boolean>(false);
  const [animarImagen, setAnimarImagen] = useState<boolean>(false);

  useEffect(() => {
    setCargar(true);
    setTimeout(() => {
      setAnimarImagen(true); // Activar la animación
      setCargar(false);
    }, 500);
  }, []);

  const fondo = () => {
    return {
      minHeight: "100vh",
    };
  };

  const handleSlideChange = () => {
    setAnimarImagen(false); // Activa la animación cada vez que cambies de diapositiva
    setTimeout(() => {
      setAnimarImagen(true); // Activar la animación
    }, 500);
  };

  return (
    <>
      {cargar && <Loading />}
      <main
        className="d-flex flex-column justify-content-between"
        style={fondo()}
      >
        <HeaderMain />
        <Swiper
          spaceBetween={30}
          loop={true}
          effect={"fade"}
          navigation={true}
          pagination={{
            clickable: true,
          }}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
          }}
          modules={[EffectFade, Navigation, Pagination, Autoplay]}
          className="mySwiper"
          onSlideChange={handleSlideChange}
        >
          <SwiperSlide>
            <div className="contenedor">
              <div
                className={`background_container ${
                  animarImagen ? "imagenFondoAnimada" : ""
                }`}
              >
                <img
                  src={homeCorporativo}
                  alt="Fonde msw"
                  className="imagenFondo"
                />
              </div>
              <div className="imagenTexto">
                <img
                  width="650px"
                  src={textoCorporativo}
                  alt="Fondo corporativo"
                />
                <span style={{ paddingBottom: "2rem", fontSize: "1.3rem" }}>
                  Nuestro enfoque multidisciplinario abarca diferentes sectores
                  de la industria como desarrollo de software, análisis químicos
                  metalúrgicos, seguridad, cuidado del medio ambiente,topografía
                  y cuidado de la salud.
                </span>
                <span style={{ paddingBottom: "2rem", fontSize: "1.2rem" }}>
                  Descubre cómo nuestras empresas conectan en cada aspecto de tu
                  negocio.
                </span>
              </div>
            </div>
          </SwiperSlide>
          //desarrollo
          <SwiperSlide>
            <div className="contenedor">
              <div
                className={`background_container ${
                  animarImagen ? "imagenFondoAnimada" : ""
                }`}
              >
                <img
                  src={desarrolloCorporativo}
                  alt="Fondo Dev"
                  className="imagenFondo"
                />
              </div>
              <div className="imagenTexto">
                <img width="750px" src={textoDesarrollo} alt="logoDEV" />
                <span style={{ paddingBottom: "3rem", fontSize: "1.5rem" }}>
                  Transformamos ideas en soluciones digitales excepcionales.
                </span>
                <a
                  href={ANCLAS.DESARROLLO}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={botonDesarrollo} alt="Fondo Laboratorio" />
                </a>
              </div>
            </div>
          </SwiperSlide>
          //laboratorio
          <SwiperSlide>
            <div className="contenedor">
              <div
                className={`background_container ${
                  animarImagen ? "imagenFondoAnimada" : ""
                }`}
              >
                <img
                  src={laboratorioCorporativo}
                  alt="Fondo Laboratorio"
                  className="imagenFondo"
                />
              </div>
              <div className="imagenTexto">
                <img
                  width="700px"
                  src={textoLaboratorio}
                  alt="Fondo Laboratorio"
                />
                <span style={{ paddingBottom: "2rem", fontSize: "1.5rem" }}>
                  Nuestro compromiso con la investigación de procesos mineros y
                  metalúrgicos, nos respaldan.
                </span>
                <a
                  href={ANCLAS.LABORATORIO}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={botonLaboratorio} alt="Fondo Laboratorio" />
                </a>
              </div>
            </div>
          </SwiperSlide>
          //cuidarte
          <SwiperSlide>
            <div className="contenedor">
              <div
                className={`background_container ${
                  animarImagen ? "imagenFondoAnimada" : ""
                }`}
              >
                <img
                  src={cuidarte2}
                  alt="Fondo Laboratorio"
                  className="imagenFondo"
                />
              </div>
              <div className="imagenTexto">
                <img width="700px" src={logoCuidarte} alt="Fondo Laboratorio" />
                <span style={{ paddingBottom: "2rem", fontSize: "1.5rem" }}>
                  Empresa dedicada a brindar un servicio de calidad y calidez
                  profesional a los pacientes en casa, dando un trato digno,
                  respetuoso.
                </span>
                <a
                  href={ANCLAS.Cuidarte}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={botonCuidarte} alt="Fondo Laboratorio" />
                </a>
              </div>
            </div>
          </SwiperSlide>
          //ambiental
          <SwiperSlide>
            <div className="contenedor">
              <div
                className={`background_container ${
                  animarImagen ? "imagenFondoAnimada" : ""
                }`}
              >
                <img
                  src={ambiental}
                  alt="Fondo Ambiental"
                  className="imagenFondo"
                  style={{ filter: "brightness(0.8)" }}
                />
              </div>
              <div className="imagenTexto">
                <img width="600px" src={logoAmbiental} alt="Fondo ambiental" />
                <span style={{ paddingBottom: "2rem", fontSize: "1.5rem" }}>
                  Empresa dedicada al cuidado y conservación de la flora y
                  fauna.
                </span>
                <a
                  href={ANCLAS.AMBIENTAL}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={botonAmbiental} alt="Fondo ambiental" />
                </a>
              </div>
            </div>
          </SwiperSlide>
          //aleante
          <SwiperSlide>
            <div className="contenedor">
              <div
                className={`background_container ${
                  animarImagen ? "imagenFondoAnimada" : ""
                }`}
              >
                <img
                  src={aleanteCorporativo}
                  alt="Fondo Aleante"
                  className="imagenFondo"
                />
              </div>
              <div className="imagenTexto">
                <img width="600px" src={logoAleante} alt="Fondo aleante" />
                <span style={{ paddingBottom: "2rem", fontSize: "1.5rem" }}>
                  Consultoría de ingenierías topografía y geomática, supervisión
                  de obra civil y calidad.
                </span>
                {/* <a
                  href={ANCLAS.ALEANTE}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={botonAleante} alt="Fondo ambiental" />
                </a> */}
              </div>
            </div>
          </SwiperSlide>
        </Swiper>
      </main>
    </>
  );
}

export default App;
